import { Box } from "@mui/material";

import { CARD_SX } from "./constants";
import { fmtCurrencyExact, fmtNumber } from "./formatters";
import { CardTitle } from "./primitives";
import { ZoneRow, ZoneStat } from "./zoneStats";

import type { TwoZoneMetrics } from "./twoZoneMetrics";

const IN_FLIGHT_HELP =
  "Total premium from groups that have a quote but no final carrier decision yet.";
const TO_WIN_HELP =
  "In-flight premium currently on a non-preferred carrier — winnable onto a preferred carrier.";
const TO_DEFEND_HELP =
  "In-flight premium currently on a preferred (Tier 1 or Tier 2) carrier — to be defended.";
const GROUPS_PENDING_HELP =
  "Number of groups that have a quote but no final carrier decision yet.";

type UndecidedZoneCardProps = {
  undecided: TwoZoneMetrics["undecided"];
};

function UndecidedZoneCard({
  undecided,
}: UndecidedZoneCardProps): React.JSX.Element {
  return (
    <Box
      role="group"
      aria-label="Undecided"
      sx={{ ...CARD_SX, flex: 1, minWidth: 0 }}
    >
      <CardTitle>Undecided</CardTitle>
      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <ZoneStat
          label="In flight"
          value={fmtCurrencyExact(undecided.inFlightTotal)}
          help={IN_FLIGHT_HELP}
        />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <ZoneRow
            label="To win"
            value={fmtCurrencyExact(undecided.toWin)}
            help={TO_WIN_HELP}
          />
          <ZoneRow
            label="To defend"
            value={fmtCurrencyExact(undecided.toDefend)}
            help={TO_DEFEND_HELP}
          />
          <ZoneRow
            label="Groups pending"
            value={fmtNumber(undecided.groupsPending)}
            help={GROUPS_PENDING_HELP}
          />
        </Box>
      </Box>
    </Box>
  );
}

export { UndecidedZoneCard };
